<div class="cm-container">
    <div [matMenuTriggerFor]="sideBarModeMenu" class="cm-tree-view-type-selector">
        <div>
            View:
            @switch ($viewType()) {
                @case ("tree") {
                    Structure
                }
                @case ("selectVariation") {
                    Select Variation
                }
                @case ("allVariations") {
                    All Variations
                }
                @case ("performance") {
                    Performance
                }
            }
        </div>
        <i class="far fa-chevron-down"></i>
        <mat-menu #sideBarModeMenu>
            <div>
                <button mat-menu-item (click)="viewTypeChanged.emit('tree')" [class.cm-active]="$viewType() === 'tree'" class="cm-tree-view-type-button">
                    Structure
                </button>
                @if ($can().read.menu("advancedTemplateEditor")) {
                    <button
                        mat-menu-item
                        (click)="viewTypeChanged.emit('selectVariation')"
                        [class.cm-active]="$viewType() === 'selectVariation'"
                        class="cm-tree-view-type-button"
                    >
                        Select Variation
                    </button>
                }
                <button
                    mat-menu-item
                    (click)="viewTypeChanged.emit('allVariations')"
                    [class.cm-active]="$viewType() === 'allVariations'"
                    class="cm-tree-view-type-button"
                >
                    All Variations
                </button>
                <button
                    mat-menu-item
                    (click)="viewTypeChanged.emit('performance')"
                    [class.cm-active]="$viewType() === 'performance'"
                    class="cm-tree-view-type-button"
                >
                    Performance
                </button>
            </div>
        </mat-menu>
    </div>
    @if ($viewType() === "performance") {
        <div [matMenuTriggerFor]="sceneAggregationModeMenu" class="cm-tree-view-type-selector">
            <div>
                @switch ($sceneAggregationMode()) {
                    @case ("memoryUsage") {
                        Memory
                    }
                    @case ("downloadSize") {
                        Download
                    }
                    @case ("triangles") {
                        Triangles
                    }
                }
            </div>
            <i class="far fa-chevron-down"></i>
            <mat-menu #sceneAggregationModeMenu>
                <div>
                    <button
                        mat-menu-item
                        (click)="sceneAggregationModeChanged.emit('memoryUsage')"
                        [class.cm-active]="$sceneAggregationMode() === 'memoryUsage'"
                        class="cm-tree-view-type-button"
                    >
                        Memory Usage
                    </button>
                    <button
                        mat-menu-item
                        (click)="sceneAggregationModeChanged.emit('downloadSize')"
                        [class.cm-active]="$sceneAggregationMode() === 'downloadSize'"
                        class="cm-tree-view-type-button"
                    >
                        Download Size
                    </button>
                    <button
                        mat-menu-item
                        (click)="sceneAggregationModeChanged.emit('triangles')"
                        [class.cm-active]="$sceneAggregationMode() === 'triangles'"
                        class="cm-tree-view-type-button"
                    >
                        Number of Triangles
                    </button>
                </div>
            </mat-menu>
        </div>
    }
</div>
